<template>
  <div class="comment-tool">
    <div class="comment-area">
        <el-input
            type="textarea"
            placeholder="来都来了，说点什么呗..."
            maxlength="500"
            show-word-limit
            resize="none"
            ref="$el-comment"
            v-model="content">
        </el-input>
        <div class="img-area">
            <span v-for="img in images.split(';').filter(img => img)" :key="img" class="img-area-item">
                <img class="img" v-lazy="img" alt="">
                <img class="img-delete" :src="require('@/assets/images/close-icon.png')" alt="" @click="handleDeleteImg(img)">
            </span>
        </div>
    </div>
    <div class="flex comment-oper">
        <div class="comment-oper-icon">
            <!-- <span><i class="el-icon-help"></i>添加表情包</span> -->
            <!-- <span>
                <img :src="require('@/assets/images/emoji.png')" alt="" width="24" style="margin-right: 10px; vertical-align: middle; "/>
                <span>添加表情包</span>
            </span> -->
            <el-upload
                class="cover-uploader"
                ref="upload"
                action="/TobDesign/api/article/uploadImage"
                :show-file-list="false"
                :on-success="handleImgSuccess"
                :before-upload="beforeImgUpload"
                accept="image/jpeg,image/jpg,image/png"
            >
                <span>
                    <img :src="require('@/assets/images/pic.png')" alt="" width="24" style="margin-right: 10px; "/>
                    <span style="vertical-align: super; ">添加图片</span>
                </span>
            </el-upload>
        </div>
        <el-button size="mini" type="primary" :loading="submitLoading" @click="handleSubmit">发布</el-button>
    </div>
  </div>
</template>

<script>
import { publishComment } from '@/api/comment';

const MaxCommentImgLen = 5;

export default {
    name: 'PublishComment',
	inject: ['checkToken'],
    props: {
        type: { // 评论对象类型
            type: Number,
            required: true,
        },
        sourceId: { // 评论对象ID
            type: [Number, String],
            required: false,
            default: () => '',
        },
        parentId: { // 回复评论ID
            type: [Number, String],
            required: false,
            default: () => '',
        },
    },
    data: () => ({
        content: '', // 评论内容
        images: '', // 图片列表
        submitLoading: false, // 发表评论加载状态
    }),
    mounted() {
        this.$nextTick(() => {
            this.$on('comment-focus', function() {
                this.$refs["$el-comment"].focus();
            });
        });
    },
    methods: {
        // 点击发表评论
        handleSubmit() {
            if (!this.checkToken()) return ;
            if (!this.content && (!this.images || !this.images.split(';').length)) {
                this.$message.warning('你什么都还没有说哦~');
                return;
            }
            this.submitComment();
        },
        // 发表评论
        submitComment() {
            const param = {
                content: this.content,
                images: this.images,
                sourceType: this.type
            };
            this.submitLoading = true;
            this.sourceId && (param.sourceId = this.sourceId);
            this.parentId && (param.parentId = this.parentId);
            publishComment(param).then(() => {
                this.$message.success('发表成功');
                this.$emit('call-back');
            }).finally(() => {
                this.content = '';
                this.images = '';
                this.submitLoading = false;
            });
        },
        // 上传图片
        handleImgSuccess(res) {
            this.images += `${res.data};`
        },
        // 上传图片前校验
        beforeImgUpload(file) {
            const isIMG = ['image/jpg', 'image/jpeg', 'image/png', 'image/gif'].includes(file.type);
            const isLt500KB = file.size / 1024 / 1024 < 10;
            
            if (this.images.split(';').length - 1 === MaxCommentImgLen) {
                this.$message.error(`图片最多上传${MaxCommentImgLen}张`);
                return false;
            }
            if (!isIMG) {
                this.$message.error('请上传图片');
                return false;
            }

            if (!isLt500KB) {
                this.$message.error('上传图片大小不能超过 10M!');
            }
            return isIMG && isLt500KB;
        },
        // 点击删除文件
        handleDeleteImg(img) {
            this.images = this.images.replace(`${img};`, '');
        }
    }
}
</script>

<style lang="scss" scoped>
.topic-item-extra {
    margin-left: 20px;
}
.comment-tool {
    margin: 20px 0;
}
.comment-area {
    position: relative;
    background-color: #fff;
    border-radius: 4px;
    border: 1px solid #EEF0FE;
    height: 140px;
    /deep/ .el-textarea {
        position: initial;
        &__inner {
            border: none;
            background-color: transparent;
            height: 60px;
        }
        .el-input__count {
            background-color: transparent;
        }
    }
    .img-area {
        position: absolute;
        bottom: 0;
        left: 0;
        margin-bottom: 10px;
        padding-left: 20px;
        height: 60px;
        &-item {
            display: inline-block;
            position: relative;
            height: 60px;
            .img {
                margin-right: 10px;
                border-radius: 4px;
                width: 90px;
                height: 100%;
            }
            .img-delete {    
                position: absolute;
                right: 2px;
                top: -6px;
                cursor: pointer;
            }
        }
    }
}
.comment-oper {
    margin: 20px 0;
    /deep/ .el-button--mini {
        padding: 7px 37px;
    }
    &-icon {
        display: flex;
        font-size: 14px;
        >span {
            display: inline-block;
            margin-right: 20px;
            cursor: pointer;
        }
        [class*="el-icon-"] {
            padding-right: 5px;
            color: #2C54EF;
        }
    }
}
</style>
